import React, { createContext } from "react";

export const TextFormatContext = createContext();

export const TextFormatProvider = ({ children }) => {
  const formatText = (text) => {
    if (!text) return "";
    // Baş harfleri büyük yap, diğerlerini küçük
    return text
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <TextFormatContext.Provider value={{ formatText }}>
      {children}
    </TextFormatContext.Provider>
  );
};
